'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { useSnackbar } from '@repo/ui/Snackbar/useSnackbar';
import type { KeyboardEventHandler, SubmitEventHandler } from 'react';
import { useAnswer } from '@/entities/answer/model/hooks';
import type { HydratedStepConfig } from '@/shared/config/funnel/types';
import { useIsFunnelSubmitting } from '../../model/Context/hooks';
import { useFunnelNavigation } from '../../model/useFunnelNavigation';
import { MultiSelectInput } from './MultiSelectInput';
import { NumberInput } from './NumberInput';
import { SearchableGroupedMultiSelectInput } from './SearchableGroupedMultiSelectInput';
import { SingleSelectInput } from './SingleSelectInput';
import { ERROR_MESSAGE_BY_TYPE, getFunnelStepFormId, handleFunnelFormEnterKey, pendingFieldsetClass } from './utils';
type Props = {
  step: HydratedStepConfig;
};
export function Form(t0) {
  const $ = _c(26);
  const {
    step
  } = t0;
  const {
    advance
  } = useFunnelNavigation();
  const snackbar = useSnackbar();
  const {
    value
  } = useAnswer(step.id);
  const isSubmitting = useIsFunnelSubmitting();
  let t1;
  if ($[0] !== advance || $[1] !== isSubmitting || $[2] !== snackbar || $[3] !== step.id || $[4] !== step.skippable || $[5] !== step.type || $[6] !== value) {
    t1 = e => {
      e.preventDefault();
      if (isSubmitting) {
        return;
      }
      const hasAnswer = Array.isArray(value) ? value.length > 0 : value !== undefined;
      const canAdvance = step.skippable || hasAnswer;
      if (!canAdvance) {
        snackbar.error({
          title: ERROR_MESSAGE_BY_TYPE[step.type]
        });
        return;
      }
      advance(step.id, hasAnswer ? value : undefined);
    };
    $[0] = advance;
    $[1] = isSubmitting;
    $[2] = snackbar;
    $[3] = step.id;
    $[4] = step.skippable;
    $[5] = step.type;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const onSubmit = t1;
  let child;
  bb0: switch (step.type) {
    case "single-select":
      {
        let t2;
        if ($[8] !== step) {
          t2 = <SingleSelectInput step={step} />;
          $[8] = step;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        child = t2;
        break bb0;
      }
    case "multi-select":
      {
        let t2;
        if ($[10] !== step) {
          t2 = <MultiSelectInput step={step} />;
          $[10] = step;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        child = t2;
        break bb0;
      }
    case "searchable-grouped-multi-select":
      {
        let t2;
        if ($[12] !== step) {
          t2 = <SearchableGroupedMultiSelectInput step={step} />;
          $[12] = step;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        child = t2;
        break bb0;
      }
    case "number-input":
      {
        let t2;
        if ($[14] !== step) {
          t2 = <NumberInput step={step} />;
          $[14] = step;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        child = t2;
      }
  }
  let t2;
  if ($[16] !== step.id) {
    t2 = getFunnelStepFormId(step.id);
    $[16] = step.id;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      flexDirection: "column",
      flex: "1",
      minHeight: "[0]",
      height: "[100%]"
    });
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== child || $[20] !== isSubmitting) {
    t4 = <fieldset disabled={isSubmitting} className={pendingFieldsetClass}>{child}</fieldset>;
    $[19] = child;
    $[20] = isSubmitting;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== onSubmit || $[23] !== t2 || $[24] !== t4) {
    t5 = <form id={t2} onSubmit={onSubmit} onKeyDown={handleFunnelFormEnterKey} className={t3}>{t4}</form>;
    $[22] = onSubmit;
    $[23] = t2;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}